import React from "react";

export default function VoucherNarration({
  narration,
  onChange,
  onEnterPress,
  maxLength = 500,
}) {
  const handleKeyDown = (e) => {
    if (e.key === "Enter" && !e.shiftKey) {
      e.preventDefault();
      onEnterPress?.();
    }
  };

  return (
    <div className="vch_narration_section">
      <div className="d-flex justify-content-between align-items-center mb-1">
        <label className="vch_field_label mb-0">Narration</label>
        <div className="vch_narration_counter">
          <span>{narration.length}</span> / {maxLength}
        </div>
      </div>
      <div className="vch_narration_wrapper">
        <textarea
          id="vch_narration_input"
          className="vch_form_control vch_narration_textarea"
          rows={2}
          maxLength={maxLength}
          value={narration}
          onChange={(e) => onChange(e.target.value)}
          onKeyDown={handleKeyDown}
          placeholder="Enter narration / description..."
        />
      </div>
    </div>
  );
}
